import React from 'react';
import { arrayforMulti } from './utils';
import MultiSelect from './MultiSelect';

const SelectService = ({ services, onChange, selectedItems }) => {
    const allItems = arrayforMulti(services);

    return (
        <MultiSelect
            allItems={allItems}
            onChange={onChange}
            selectedItems={selectedItems}
            title="Services"
        />
    );
};

export default SelectService;
